module.exports = __webpack_public_path__ + "assets/img/happy.6c33ec00.png";